import {
  debounce
} from './../utils';

export function filterByLinks(lazymap) {
  const links = document.querySelectorAll('.delivery-box__link');

  links.forEach((link) => {
    new Link(link, lazymap);
  });
}

class Link {
  constructor(elem, lazymap) {
    this._elem = elem;
    this._lazymap = lazymap;
    this._company = this._elem.dataset.filter;


    this.elemClickHandler = this.elemClickHandler.bind(this);
    this.filterAndScroll = debounce(this.filterAndScroll.bind(this));
    this._elem.addEventListener('click', this.elemClickHandler);
  }

  elemClickHandler(evt) {
    evt.preventDefault();

    this.filterAndScroll();
  }

  filterAndScroll() {
    if (this._lazymap.getMap()) {
      this._lazymap.getMap().filterByCompany(this._company);
    } else {
      this._lazymap.removeScrollHandler();
      this._lazymap.loadMap().then((self) => {
        self.filterByCompany(this._company);
      });
    }
  }
}
